import React from 'react'
import PropTypes from 'prop-types'
import Container from 'src/components/Container'

const StepNav = props => {
  const { onStep1Click, onStep2Click, currentStep } = props
  const stepsData = [
    {
      title: 'Select a service',
    },
    {
      title: 'Subject',
    },
    {
      title: 'Your feedback',
    },
  ]
  return (
    <div className="text-center border-b border-primary-lighter px-12">
      <Container>
        <nav className="flex flex-wrap flex-col sm:flex-row justify-center sm:justify-around sm:content-center mx-auto h-16 sm:h-20">
          {stepsData.map((step, index) => {
            let stepIndex = index + 1
            const { title } = step
            return (
              <button
                key={title}
                onClick={() => {
                  switch (index + 1) {
                    case 1:
                      onStep1Click && onStep1Click()
                      break
                    case 2:
                      onStep2Click && onStep2Click()
                      break
                    default:
                      break
                  }
                }}
                className={`${
                  currentStep === stepIndex ? 'shown' : 'hidden md:inline-block'
                } text-body-light font-semibold outline-none my-1 sm:my-2`}
              >
                <span
                  className={`${
                    currentStep >= stepIndex
                      ? 'text-secondary'
                      : 'text-body-lighter'
                  }`}
                >
                  <span>{stepIndex}.</span>
                  <span className="ml-2">{title}</span>
                </span>
              </button>
            )
          })}
        </nav>
      </Container>
    </div>
  )
}

StepNav.propTypes = {
  currentStep: PropTypes.number,
  onStep1Click: PropTypes.func,
  onStep2Click: PropTypes.func,
}

export default StepNav
